import styles from "../styles/BrandButton.module.css";

export default function BrandButton({ children, className = "", onClick, type = "button", size = "normal", variant, ...rest }) {
  void variant;

  const buttonClass = [
    styles.button,
    size === "large" ? styles.large : "",
    className,
  ].filter(Boolean).join(" ");

  return (
    <button type={type} className={buttonClass} onClick={onClick} {...rest}>
      {children}
    </button>
  );
}
